import {Configuration, ConfigurationParameters} from "./axios/index"
import { devuelveBasePath } from '@utils'

const params: ConfigurationParameters = {
    basePath: devuelveBasePath()
}

export const settings = new Configuration(params)

export * from "./axios/index"
